import update from 'react-addons-update';
import ErrorCode from 'core/errorCode';
import { i18n } from 'core/i18n';
import assign from 'object-assign';

import {
	MAIN_OPEN_MASK,
	MAIN_CLOSE_MASK,
	MAIN_OPEN_ERROR,
	MAIN_CLOSE_ERROR,

	MAIN_POST_SESSION_SUCCESS,
	MAIN_DELETE_SESSION_SUCCESS,
	MAIN_GET_ACCOUNT_BALANCE_SUCCESS,
	MAIN_CHANGE_LANUAGE,
	MAIN_GET_TRANSLATION_SUCCESS,
	MAIN_GET_APP_SETTINGS_SUCCESS,
	MAIN_POST_ROLE_SUCCESS,
	MAIN_GET_ALL_AGENT
} from './action.js';

const initState = {
	action: null,
	errorState: false,
	errorMessage: '',
	errorHeader: '',
	errorRedirect: '',
	loading: false,
	lang: {
		label: '中文',
		value: 'zh-tw'
	},
	langRedirect: false,
	balanceInfo: null,
	translationData: null,
	appSettings: null,
	flightOptionObject: {
		'zh-tw': [],
		'jp': [],
		'kr': [],
		'th': [],
		'en': []
	},
	langOptions: [
		{
			label: 'English',
			value: 'en-US'
		}, {
			label: '中文',
			value: 'zh-TW'
		}, {
			label: '日本語',
			value: 'ja-JP'
		}, {
			label: '한국어',
			value: 'ko-KR'
		}, {
			label: 'ไทย',
			value: 'th-TH'
		}
	],
	currencyOptions: [],
	titleOptions: [
		{
			label: i18n('mr'),
			value: 'MR'
		}, {
			label: i18n('ms'),
			value: 'MS'
		}
	],
	dialCodeOptions: {
		'zh-tw': [],
		'jp': [],
		'kr': [],
		'th': [],
		'en': []
	},
	countryCodeOptions: {
		'zh-tw': [],
		'jp': [],
		'kr': [],
		'th': [],
		'en': []
	},
	addressStateOptions: [
		{
			label: 'OTH',
			value: 'OTH'
		}
	],
	roleOptions: null,
	statusOptions: [
		{
			label: 'Active',
			value: 0
		},
		{
			label: 'Terminated',
			value: 1
		},
		{
			label: 'Suspended',
			value: 2
		}
	],
	agentList: null
};

const handleCountryAndDialCode = (translationData) => {
	let countryCodeOptions = {
			'zh-tw': [],
			'jp': [],
			'kr': [],
			'th': [],
			'en': []
		},
		dialCodeOptions = {
			'zh-tw': [],
			'jp': [],
			'kr': [],
			'th': [],
			'en': []
		};
	
	if (translationData) {
		// 語系array: ['zh-tw', 'jp', 'kr', 'th', 'en']
		Object.keys(translationData).forEach((lang) => {
			
			if (translationData[lang] && translationData[lang].countries) {
				// 國家代碼array
				let countriesKeys = Object.keys(translationData[lang].countries) || [];

				// 重新排序國家
				let sortedArr = ['TW', 'JP', 'KR', 'TH', 'CN', 'MO', 'HK', 'PH'];

				for (let i = 0; i < sortedArr.length; i++) {
					let index = countriesKeys.indexOf(sortedArr[i]);
					// 拔除
					if (index !== -1) {
						countriesKeys.splice(index, 1);
					}
					// 加入
					countriesKeys.splice(i, 0, sortedArr[i]);
				}

				// 處理各語系國碼 & 國籍下拉選單
				countriesKeys.forEach((item) => {
					countryCodeOptions[lang].push({
						label: translationData[lang].countries[item].name,
						value: translationData[lang].countries[item].code
					});

					// 過濾無國碼之國家
					if (translationData[lang].countries[item].dialCode) {
						dialCodeOptions[lang].push({
							label: `${translationData[lang].countries[item].name} (${translationData[lang].countries[item].dialCode})`,
							value: translationData[lang].countries[item].dialCode,
							countryCode: translationData[lang].countries[item].code
						});
					}
				});
			}
		});
	}

	return ({ countryCodeOptions, dialCodeOptions });
};

const combineFlightOptionObject = (translationData) => {
	let flightOptionObject = {};
	Object.keys(translationData).map((key) => {
		let selectOptionArr = [];
		Object.keys(translationData[key].origindestination).map((ogKey) => {
			let optionsObj = {};
			let optionsArr = [];
			Object.keys(translationData[key].origindestination[ogKey]).map((k) => {
				optionsObj = {
					label: translationData[key].origindestination[ogKey][k].name + (translationData[key].origindestination[ogKey][k].isMac ? '' : `(${translationData[key].origindestination[ogKey][k].code})`),
					value: translationData[key].origindestination[ogKey][k].code,
					markets: translationData[key].origindestination[ogKey][k].markets,
					currencyCode: translationData[key].origindestination[ogKey][k].currencyCode
				};
				optionsArr.push(optionsObj);
				return true;
			});
			selectOptionArr.push({
				label: translationData[key].countries[ogKey].name,
				options: optionsArr,
				code: translationData[key].countries[ogKey].code
			});
			return true;
		});
		let obj = {};
		obj[key] = selectOptionArr;
		assign(flightOptionObject, obj);
		return true;
	});
	return flightOptionObject;
}

const handleRoleOptions = (data) => {
	let roleOptions = [];

	Object.keys(data).forEach((key) => {
		roleOptions.push({
			label: data[key],
			value: key
		});
	});

	return roleOptions;
}

const handleCurrencyOptions = (data) => {
	let currencyOptions = [];

	data.forEach((item) => {
		currencyOptions.push({
			label: item,
			value: item
		});
	});

	return currencyOptions;
}

export default function mainReducer(state = initState, action) {
	switch (action.type) {
		case MAIN_OPEN_MASK:
			return update(state, {
				loading: { $set: true }
			});
		case MAIN_CLOSE_MASK:
			return update(state, {
				loading: { $set: initState.loading }
			});
		case MAIN_OPEN_ERROR:
			let error = ErrorCode.errorCodeMaping(action.errorResponse, action.errorType);
			return update(state, {
				errorState: { $set: true },
				errorMessage: { $set: error.errorMessage },
				errorHeader: { $set: action.errorHeader },
				errorRedirect: { $set: error.errorRedirect }
			});
		case MAIN_CLOSE_ERROR:
			return update(state, {
				errorState: { $set: initState.errorState },
				errorMessage: { $set: initState.errorMessage },
				errorHeader: { $set: initState.errorHeader }
			});
		case MAIN_POST_SESSION_SUCCESS:
			return state;
		case MAIN_DELETE_SESSION_SUCCESS:
			return state;
		case MAIN_GET_ACCOUNT_BALANCE_SUCCESS:
			return update(state, {
				balanceInfo: { $set: action.data }
			});
		case MAIN_GET_TRANSLATION_SUCCESS:
			let flightOptionObject = combineFlightOptionObject(action.data),
				countriesOptions = handleCountryAndDialCode(action.data);
			return update(state, {
				action: { $set: action.type },
				translationData: { $set: action.data },
				flightOptionObject: { $set: flightOptionObject },
				countryCodeOptions: { $set: countriesOptions.countryCodeOptions },
				dialCodeOptions: { $set: countriesOptions.dialCodeOptions }
			});
		case MAIN_GET_APP_SETTINGS_SUCCESS:
			let initCurrencyOptions = [];
			if (action.data && action.data.supportCurrencyCodes) {
				initCurrencyOptions = handleCurrencyOptions(action.data.supportCurrencyCodes);
			}
			return update(state, {
				action: { $set: action.type },
				appSettings: { $set: action.data },
				currencyOptions: { $set: initCurrencyOptions }
			});
		case MAIN_POST_ROLE_SUCCESS:
			let _roleOptions = [];
			if (action.data) {
				_roleOptions = handleRoleOptions(action.data);
			}
			return update(state, {
				roleOptions: { $set: _roleOptions }
			});
		case MAIN_CHANGE_LANUAGE:
			let _titleOptions = [
				{
					label: i18n('mr'),
					value: 'MR'
				}, {
					label: i18n('ms'),
					value: 'MS'
				}
			];
			return update(state, {
				action: { $set: action.type },
				lang: { $set: action.data },
				titleOptions: { $set: _titleOptions }
			});
		case MAIN_GET_ALL_AGENT:
			let agentList = action.data;
			let agentListArray = [];
			Object.keys(agentList).map((key) => {
				agentListArray.push({
					'label': agentList[key],
					'value': key
				});
				return true;
			});
			return update(state, {
				action: { $set: action.type },
				agentList: { $set: agentListArray }
			});
		default:
			return state;
	}
}